import {
	Button,
	Col,
	Form,
	Input,
	Popconfirm,
	Row,
	Select,
	notification,
} from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner } from "../utils/CustomComponents";
const { TextArea } = Input;

const statusOptions = [
	{
		value: "Enabled",
		label: "Enabled",
	},
	{
		value: "Out of Service",
		label: "Out of Service",
	},
	{
		value: "In Maintenance",
		label: "In Maintenance",
	},
];

const LogisticsTruck = (props) => {
	const [form] = Form.useForm();
	const [initialValues, setInitialValues] = useState({});
	const [loading, setLoading] = useState(false);
	const [loadingForm, setLoadingForm] = useState(true);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getTruck();
	}, []);

	const getTruck = async () => {
		const url = api + "/logisticstruck/get/" + props.match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			setInitialValues({
				...initialValues,
				number: data.number,
				status: data.status,
				truckLicensePlates: data.truckLicensePlates,
				truckVinNumber: data.truckVinNumber,
				trailerLicensePlates: data.trailerLicensePlates,
				trailerVinNumber: data.trailerVinNumber,
				comment: data.comment,
			});
			setLoadingForm(false);
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to get truck");
			console.error(err.message);
			return null;
		}
	};

	const deleteTruck = async () => {
		setLoading(true);

		const url = api + "/logisticstruck/delete/" + props.match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			await axios.delete(url);
			openNotification("info", "Info", "Truck Deleted");
			setLoading(false);
			props.history.push("/logisticstrucklist");
		} catch (err) {
			setLoading(false);
			console.error(err.message);
			return null;
		}
	};

	const updateTruck = async (data) => {
		const truck = {
			number: data.number,
			status: data.status,
			truckLicensePlates: data.truckLicensePlates,
			truckVinNumber: data.truckVinNumber,
			trailerLicensePlates: data.trailerLicensePlates,
			trailerVinNumber: data.trailerVinNumber,
			comment: data.comment,
		};

		try {
			let url = api + "/logisticstruck/update/" + props.match.params.id;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			await axios.patch(url, truck);
			openNotification("success", "Success", "Truck updated");
			setLoading(false);
			props.history.push("/logisticstrucklist");
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to update truck");
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		setLoading(true);
		updateTruck(values);
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				initialValues={initialValues}
			>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Truck Number"
							name="number"
							rules={[
								{
									required: true,
									message: "Please fill truck number",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Truck Plates"
							name="truckLicensePlates"
							rules={[
								{
									required: true,
									message: "Please fill truck plates",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Truck VIN"
							name="truckVinNumber"
							rules={[
								{
									required: true,
									message: "Please fill truck vin",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item label="Trailer Plates" name="trailerLicensePlates">
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item label="Trailer VIN" name="trailerVinNumber">
							<Input size="large" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={24}>
						<Form.Item label="Comment" name="comment">
							<TextArea rows={4} />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item label="Status" name="status">
							<Select
								allowClear={false}
								placeholder={`Select status`}
								size="large"
								options={statusOptions}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col>
						<Button type="primary" htmlType="submit" loading={loading}>
							Save
						</Button>
					</Col>
					{(localStorage.getItem("email") === "eliud@gmail.com" ||
						localStorage.getItem("email") === "pc@57concrete.com" ||
						localStorage.getItem("email") === "jc@57concrete.com" ||
						localStorage.getItem("email") === "gg@57xgroup.com" ||
						localStorage.getItem("email") === "ec@57concrete.com") && (
						<Col>
							<Popconfirm
								title="Delete the truck"
								description="Are you sure to delete this truck?"
								okText="Yes"
								cancelText="No"
								onConfirm={deleteTruck}
							>
								<Button
									danger
									type="primary"
									htmlType="button"
									loading={loading}
								>
									Delete
								</Button>
							</Popconfirm>
						</Col>
					)}
				</Row>
			</Form>
		);
	};

	return (
		<Layout
			title="Logistics Truck"
			description="Edit Logistics Truck"
			type="medium"
		>
			{contextHolder}
			{loadingForm ? <CustomSpinner /> : <CustomForm />}
		</Layout>
	);
};

export default LogisticsTruck;
